export default __webpack_public_path__ + "static/logo-aib-cc96638870339b07ba0482073cc0a163.webp";